const checkCloudSpaceLimit = (ts) => {
    if (ts.isFullCouldSpace) {
        if (!ts.vip && this.showUpgradeVal !== "cloudSpace") {
            ts.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
        } else if (ts.showUpgradeVal !== "cloudSpaceVIP") {
            ts.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
        }
        return true;
    }
    return false;
};

export default checkCloudSpaceLimit;
